<template>
  <div class="ai-config-tree">
    <template v-if="Array.isArray(value)">
      <p v-if="!value.length" class="lab-hint">未设置条目</p>
      <details v-for="(row, index) in value" :key="index" class="ai-config-row">
        <summary>{{ rowTitle(row, index) }}</summary>
        <ai-case-config-tree :value="row" :definition="definition" />
      </details>
    </template>
    <dl v-else-if="value && typeof value === 'object'" class="ai-config-fields">
      <template v-for="(child, key) in value">
        <div v-if="show(key)" :key="key" :class="{ 'ai-config-nested': isObject(child) }">
          <dt>{{ label(key) }}</dt>
          <dd v-if="isObject(child)"><ai-case-config-tree :value="child" :definition="definition" /></dd>
          <dd v-else :class="{ 'ai-config-formula': key === 'formula' }">{{ display(key, child) }}</dd>
        </div>
      </template>
    </dl>
    <span v-else>{{ value === null ? '—' : value }}</span>
  </div>
</template>
<script>
const labels = {
  name: '名称', desc: '说明', intro: '案例简介', caseType: '案例类型', level: '等级 / 紧急程度', duration: '实训时长（分钟）', hours: '学时', cover: '封面',
  regionName: '辖区名称', area: '面积（km²）', population: '人口（人）', economy: '经济水平', formula: '计算公式', duty: '职责', staff: '人员编制', role: '岗位', per: '每网格配置人数',
  districts: '功能分区', zone: '功能分区', code: '编号', cells: '底图单元数', key: '指标标识', weight: '权重 / 满分',
  id: '编号', type: '类别', dep: '责任部门', dept: '所属部门', hint: '处置提示', no: '案件编号', title: '案件标题', cat: '案件类别', grid: '所属网格', minute: '触发时间（分钟）',
  affectedPeople: '影响人数', durationDays: '持续天数', eventType: '关联事件', eff: '事件影响', pol: '政治效益', soc: '社会效益', eco: '经济水平 / 经济效益', env: '环境效益', item: '评分项目',
  info: '背景信息', exec: '执行介绍 / 执行指标', policy: '公共政策', pop: '人数', note: '目标对象说明', auth: '权威资源', budget: '财政预算（万元）', period: '实施周期（天）',
  evt: '事件类型', cases: '案件清单', core: '核心指标', midx: '措施指标', res: '资源设置', measures: '措施清单', evalItems: '评估指标', evalLevels: '评估等级',
  regions: '地区', depts: '部门', short: '简称', icon: '图标', scene: '部门场景', enable: '是否启用', risk: '风险等级',
  cost: '财政花费（万元）', weights: '贡献权重', willing: '意愿 / 知晓', registered: '登记 / 评估', result: '服务成效', satis: '满意度',
  unit: '单位', init: '初值', target: '目标值', semantic: '核心语义', ref: '触发源', cond: '触发条件', advice: '应对建议', k: '等级编号', min: '最低分'
}
export default {
  name: 'AiCaseConfigTree', props: { value: { required: true }, definition: { type: Object, default: () => ({}) } },
  methods: {
    isObject (value) { return value !== null && typeof value === 'object' },
    show (key) { return !['shared', 'published', 'custom', 'scope', 'schemaVersion', 'personnelIds', 'mapTemplateId'].includes(key) },
    label (key) { return labels[key] || key },
    rowTitle (row, index) { return row && typeof row === 'object' ? (row.name || row.title || row.role || row.item || row.code || '第' + (index + 1) + '项') : String(row) },
    display (key, value) {
      if (typeof value === 'boolean') return value ? '是' : '否'
      if (value === null || value === '') return '—'
      if (key === 'dept' || key === 'dep') { const d = ((this.definition.map || {}).depts || this.definition.depts || []).find(d => d.id === value || d.name === value); if (d) return d.name }
      if (key === 'ref' || key === 'eventType') { const row = [...(this.definition.measures || []), ...(this.definition.core || []), ...(this.definition.exec || []), ...(this.definition.midx || []), ...(this.definition.evt || [])].find(r => r.id === value || r.key === value); if (row) return row.name }
      return value
    }
  }
}
</script>
